import { ReactNode } from "react";
import { makeStyles } from "@material-ui/core";

// Wrap a react-data-table-component <DataTable> so its pagination bar renders ABOVE
// the table instead of below it — so you can page without scrolling to the bottom.
//
// RDT renders its parts as siblings (its ThemeProvider adds no DOM wrapper):
//   Header? -> Subheader? -> ResponsiveWrapper (the table) -> div (the pagination nav).
// We make this wrapper a flex column and push the table body below the pagination via
// `order`, which keeps any title/subheader on top and lifts pagination above the table.
// Pass `paginationTopClassName` to the DataTable's `className` prop so we can target
// the table body (ResponsiveWrapper) precisely.
export const paginationTopClassName = "rdt-pagination-top-body";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    [`& > .${paginationTopClassName}`]: {
      order: 1,
    },
  },
});

const PaginatedTableTop = ({ children }: { children: ReactNode }) => {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
};

export default PaginatedTableTop;
